import gql from "graphql-tag";

export const MY_VOUCHER = gql`
  query vouchers(
    $first: Int=20,
    $after: String
  ) {
    availableVouchers(
      first: $first,
      after: $after
    ) {
      pageInfo{
        endCursor
      }
      edges {
        node {
          id
          name
          endDate
          code
          type
        }
      }
    }
  }
`;